import {
  Button, Flex, Link,
  Modal, ModalBody, ModalCloseButton,
  ModalContent, ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";

const PreventLeavePageModel = ({isOpen, onOpen, onClose}) => {
  const initialRef = React.useRef();
  const finalRef = React.useRef();


  return (
    <>
      <Modal
        size='lg'
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay/>
        <ModalContent borderRadius="lg" maxW="md">
          <ModalHeader fontWeight="bold">Waarschuwing</ModalHeader>
          <ModalCloseButton/>
          <ModalBody>
            <Flex py={2}>
              <Text fontWeight={"bold"} fontSize={"md"} color={'red.300'}>
                U bent momenteel aan het notuleren, stop de notule alvorens u naar een andere pagina gaat.
              </Text>
            </Flex>
          </ModalBody>

          <ModalFooter>
            <Button
              textColor="white"
              bg="var(--primary-color)" w="100%"
              onClick={onClose}
              _hover={{
                bg: "rgba(255, 0, 0, 0.3)",
              }}
            >
              Sluiten
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default PreventLeavePageModel;
